import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetUserSearchResultLcdSubscriptions} from '../../hooks/useGetUserSearchResultLcdSubscriptions';
import {userSearchResultResultSelector} from '../../slices/user-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';

type ControllerProps = {
    userIds: number[],
    columnId: string,
};

const LcdSubscriptionsHeaderController = ({userIds, columnId}: ControllerProps) => {
    const {isLoading, loadingError} = useGetUserSearchResultLcdSubscriptions({userIds});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={columnId}
        />
    );
};

const LcdSubscriptionsHeaderBase = ({columnId}: {columnId: string}) => {
    const result = useSelector(userSearchResultResultSelector);

    return result ? (
        <LcdSubscriptionsHeaderController userIds={result.data.map(({id}) => id)} columnId={columnId}/>
    ) : (
        <HeaderSkeleton columnId={columnId}/>
    );
};

export const LcdSubscriptionNewsHeader = () => (
    <LcdSubscriptionsHeaderBase columnId={COLUMNS.LCD_SUBSCRIPTION_NEWS}/>
);

export const LcdSubscriptionResearchHeader = () => (
    <LcdSubscriptionsHeaderBase columnId={COLUMNS.LCD_SUBSCRIPTION_RESEARCH}/>
);
